<!-- SplitPaneRenderer.vue -->
<template>
  <splitpanes
    :horizontal="isHorizontal"
    style="height: 100%;"
  >
    <template
      v-for="(pane, index) in layout.children"
    >
      <pane
        :key="index"
        :min-size="pane.size"
        :size="pane.size"
        :style="pane.paneStyle || {}"
      >
        <template
          v-if="pane.children"
        >
          <SplitPaneRenderer
            :layout="pane"
          />
        </template>
        <template
          v-else
        >
          <component
            :is="pane.component"
            :data="data"
            :config="pane || {}"
          />
        </template>
      </pane>
    </template>
  </splitpanes>
</template>

<script>
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: 'SplitPaneRenderer',

  components: {
    Splitpanes,
    Pane
  },

  props: {
    layout: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    isHorizontal () {
      return this.layout.direction && this.layout.direction === 'horizontal'
    }
  }
}
</script>
